import { render, staticRenderFns } from "./BetonTvrtkaIndex.vue?vue&type=template&id=59b2a355&scoped=true&"
import script from "./BetonTvrtkaIndex.vue?vue&type=script&lang=js&"
export * from "./BetonTvrtkaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2a355",
  null
  
)

export default component.exports